import { PropsWithChildren } from "react";
import ShareIcon from "@mui/icons-material/Share";

interface Props {
  name?: string;
}

export const Icon = ({ name }: PropsWithChildren<Props>) => {
  return (
    <>
      <ShareIcon />
    </>
  );
};
